import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface SelectOption {
  value: any;
  label: string;
  icon?: string;
}

@Component({
  selector: 'app-custom-select',
  standalone: true,
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    }
  ],
  templateUrl: './custom-select.html',
  styleUrls: ['./custom-select.css']
})
export class CustomSelectComponent implements ControlValueAccessor {
  @Input() options: SelectOption[] = [];
  @Input() placeholder: string = 'Selecciona una opción';
  @Input() backgroundColor: string = '#ffffff';
  @Input() textColor: string = '#374151';
  @Input() arrowColor: string = '#6b7280';
  @Input() borderColor: string = '#e1e5e9';
  @Input() showIcon: boolean = false;
  @Input() disabled: boolean = false;
  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: any = null;
  isOpen: boolean = false;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  toggleDropdown() {
    if (this.disabled) return;

    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.onTouched();
    }
  }

  closeDropdown() {
    this.isOpen = false;
  }

  selectOption(option: SelectOption, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.selectedValue = option.value;
    this.isOpen = false;
    this.onChange(this.selectedValue);
    this.selectionChange.emit(this.selectedValue);
  }

  getSelectedOption(): SelectOption | undefined {
    return this.options.find(option => option.value === this.selectedValue);
  }

  getSelectedText(): string {
    const selected = this.getSelectedOption();
    return selected ? selected.label : this.placeholder;
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
